import React, { useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import CheckoutButtons from './CheckoutButtons';
import * as Metrics from '../../../components/utils/trackMetric';
import * as MetricEvents from '../../../../constants/metrics';

function CheckoutButtonsWrapper(props) {
  const shouldStickToBottom = props.isStickyCheckoutFooterEnabled;
  const footerRef = useRef(null);

  const updatePadding = (footerEl, containerEl) => {
    if (footerEl && containerEl) {
      containerEl.style.paddingBottom = `${footerEl.offsetHeight}px`;
    }
  };

  useLayoutEffect(() => {
    if (!shouldStickToBottom) {
      Metrics.track(MetricEvents.OLS_PDP_CHECKOUT_BUTTONS_IMPRESSION);
      return;
    }
    Metrics.track(MetricEvents.OLS_STICKY_FOOTER_CHECKOUT_BUTTONS_IMPRESSION);
    const footerEl = footerRef.current;
    const renderContainer = document.getElementById('render-container');
    if (!footerEl || !renderContainer) return;

    updatePadding(footerEl, renderContainer);

    const resizeObserver = new ResizeObserver(() => {
      updatePadding(footerEl, renderContainer);
    });

    resizeObserver.observe(footerEl);

    return () => {
      resizeObserver.disconnect();
      renderContainer.style.paddingBottom = '';
    };
  }, [shouldStickToBottom]);

  if (shouldStickToBottom) {
    return (
      <footer
        id='checkout-buttons-footer'
        ref={ footerRef }
        style={{
          position: 'fixed',
          borderTop: '1px solid rgb(226, 226, 226)',
          bottom: 0,
          left: 0,
          right: 0,
          background: 'white',
          padding: '16px',
          marginBottom: '0',
          boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)',
          zIndex: 1000,
          height: 'min-content'
        }}
      >
        <CheckoutButtons { ...props } shouldStickToBottom={ shouldStickToBottom } />
      </footer>
    );
  }

  return <CheckoutButtons { ...props } shouldStickToBottom={ shouldStickToBottom } />;
}

CheckoutButtonsWrapper.propTypes = {
  checkoutButtonMobileExperiment: PropTypes.shape({
    bucket: PropTypes.string
  }),
  isStickyCheckoutFooterEnabled: PropTypes.bool
};

export default CheckoutButtonsWrapper;
